import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { Separator } from 'apps/auth/components/common/Layout/Separator';

const GaPaymentNumber = (props) => {
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor } = props.options;

    return (
        <>
            {mobileInfo.extraFields?.Payment && (
                <>
                    <Separator marginTop="48px" marginBottom="48px" />
                    <TableContainer>
                        <TableRow title={props.chequeFromCardHeader} textColor={textColor} titleColor={titleColor}>
                            {mobileInfo.extraFields?.Payment}
                        </TableRow>
                    </TableContainer>
                </>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    chequeFromCardHeader: state.messages.pageMessages.chequeFromCardHeader,
});

export default connect(mapStateToProps)(GaPaymentNumber);
